import { StyleSheet, useWindowDimensions } from 'react-native'
import { DS } from '../../../../../design-system'
import AllowAVPermissions from '../../../../../assets/AllowAVPermissions.svg'
import { palette } from '../../../../../theme/palette'
import React from 'react'

export const AVAllow = () => {
  const { width } = useWindowDimensions()
  const isSmallDevice = width < 370

  return (
    <React.Fragment>
      <AllowAVPermissions style={[styles.image, styles.bigImageSize]} />
      <DS.Frame style={styles.textContainer} gap="32">
        <DS.Text variant="Body Large/Regular" style={{ fontSize: isSmallDevice ? 22 : 24 }}>
          Make sure to Allow Poker Power to utilize your mic for gameplay
        </DS.Text>
        <DS.Frame gap="16">
          <DS.Text variant="Body Medium/Regular" style={{ fontSize: isSmallDevice ? 12 : 14 }}>
            Don’t worry, you’ll still be able to turn off your camera and mute your mic in our games.
          </DS.Text>
        </DS.Frame>
      </DS.Frame>
    </React.Fragment>
  )
}

const styles = StyleSheet.create({
  layout: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: palette.blackWithOpacity.twenty
  },
  container: {
    backgroundColor: palette.cream,
    borderRadius: 12,
    paddingHorizontal: 32,
    paddingVertical: 64,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    maxWidth: 800
  },
  textContainer: {
    flex: 1,
    minWidth: 250
  },
  image: {
    alignSelf: 'center'
  },
  bigImageSize: {
    height: 120,
    width: 120
  },
  smallImageSize: {
    height: 200,
    width: 200
  }
})
